const math2Dot = (newN) => {
    return Math.round(newN * 100) / 100;
};
const formatSize = (size) => {
    let newN = size / 1024;
    if (newN > 1024) {
        newN = newN / 1024;
        if (newN > 1024) {
            newN = newN / 1024;
            if (newN > 1024) {
                return `${math2Dot(newN)}T`;
            }
            return `${math2Dot(newN)}G`;
        }
        return `${math2Dot(newN)}M`;
    }
    return `${math2Dot(newN)}K`;
};
export default {
    formatSize
};
//# sourceMappingURL=file.js.map